import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const t = (e) => /* @__PURE__ */ C(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(e),
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_1016_19771)", children: /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.10571 3.10571C4.93419 1.27723 7.41414 0.25 10 0.25C12.5859 0.25 15.0658 1.27723 16.8943 3.10571C18.7228 4.93419 19.75 7.41414 19.75 10C19.75 12.3417 18.9076 14.5966 17.3905 16.3595C17.4403 16.3899 17.4873 16.4266 17.5303 16.4697L23.5303 22.4697C23.8232 22.7626 23.8232 23.2374 23.5303 23.5303C23.2374 23.8232 22.7626 23.8232 22.4697 23.5303L16.4697 17.5303C16.4266 17.4873 16.3899 17.4403 16.3595 17.3905C14.5966 18.9076 12.3417 19.75 10 19.75C7.41414 19.75 4.93419 18.7228 3.10571 16.8943C1.27723 15.0658 0.25 12.5859 0.25 10C0.25 7.41414 1.27723 4.93419 3.10571 3.10571ZM10 1.75C7.81196 1.75 5.71354 2.61919 4.16637 4.16637C2.61919 5.71354 1.75 7.81196 1.75 10C1.75 12.188 2.61919 14.2865 4.16637 15.8336C5.71354 17.3808 7.81196 18.25 10 18.25C12.188 18.25 14.2865 17.3808 15.8336 15.8336C17.3808 14.2865 18.25 12.188 18.25 10C18.25 7.81196 17.3808 5.71354 15.8336 4.16637C14.2865 2.61919 12.188 1.75 10 1.75Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_1016_19771", children: /* @__PURE__ */ l("rect", { width: "24", height: "24", fill: "white" }) }) })
    ]
  }
);
export {
  t as SearchIcon
};
//# sourceMappingURL=SearchIcon.js.map
